var $ = jQuery;

import {decodeEntities} from '../utils/utilities.js';

function init() {
  const $customDropDown = $('.search-custom-dropdowns__value');
  const $searchOpen = $('.search-open');
  const $modal = $('.search-form-modal');
  const $close = $('.search__close-modal');
  const $input = $('#search_overlay_input');
  const $resultsWrapper = $('.search-form__results-wrapper');
  const $searchForm = $('#hf-search-form');
  const $typeAheadResults = $('.typeahead-results');
  // const $typeVal = $('search-custom-dropdowns__type-value');
  // const $dateVal = $('search-custom-dropdowns__date-value');

  const $searchInput = $('.search--input');
  // const $checkBoxes = $('.search-custom-dropdowns__checkbox');
  const $dateRadio = $('.search-custom-dropdowns__radio');
  const $dateInputs = $('.search-custom-dropdowns__date');

  if($customDropDown.length > 0) {
    binds();
  }
  bindSearch();

  function bindSearch() {
    $searchOpen.on('click', toggleModal);
    $close.on('click', toggleModal);
    $input.on('keyup', toggleSuggestions);

  }

  function binds() {
    $customDropDown.on('click', toggleDrop);
    $dateRadio.on('click', toggleInputs);
    $('#all-types').on('click', toggleAllChecks);
    $('.search-custom-dropdowns__checkbox:not(#all-types)').on('click', toggleTopBox);
    $('body').on('click', function() {
      $('.search-custom-dropdowns__input._active').removeClass('_active');
    });

    $searchForm.on('submit', createQuery);

    $('.search-custom-dropdowns__drawer').on('click', function(event) {
      event.stopPropagation();
    });
  }


  function toggleTopBox(event) {
    event.stopPropagation();
    $('#all-types').prop('checked', false);
    $('.search-custom-dropdowns__value');
    $('.search-custom-dropdowns__type-value').empty().html(setDropVal('type'));
    noneCheck();
  }

  function noneCheck() {
    if($('.search-custom-dropdowns__checkbox:checked').length === 0) {
      $('#all-types').prop('checked', 'checked');
      $('.search-custom-dropdowns__type-value').empty().html(setDropVal('type'));
    }
  }

  function toggleAllChecks(event) {
    event.stopPropagation();
    let $checks = $('.search-custom-dropdowns__checkbox:not(#all-types)');
    $checks.prop('checked', false);
    $('.search-custom-dropdowns__type-value').empty().html(setDropVal('type'));
    noneCheck();
  }

  function createQuery(e) {
    e.preventDefault();
    getValues();
  }

  function toggleInputs() {
    if($(this).attr('id') === 'from') {
      $dateInputs.prop('disabled', false);
    }
    else {
      $dateInputs.prop('disabled', true);
    }

    $('.search-custom-dropdowns__date-value').empty().html(setDropVal('date'));
  }

  function setDropVal(kind) {
    let inputVal;
    if(kind === 'type') {
      if($('#all-types').is(':checked')) {
        inputVal = 'All Types';
      }
      else {
        inputVal = getTypes('label').join(', ');
      }
    }
    else {
      if($('.search-custom-dropdowns__radio:checked').attr('data-label') === 'From') {
        inputVal = $('#fromDate').val() + ' - ' + $('#to').val();
      }
      else {
        inputVal = $('.search-custom-dropdowns__radio:checked').attr('data-label');
      }
    }

    return inputVal;
  }


  function lastDayOfMonth(Year, Month) {
    let dateObj = new Date( (new Date(Year, Month,1))-1);
    let month = dateObj.getMonth() +1; //months from 1-12
    let day = dateObj.getDate();
    let year = dateObj.getFullYear();
    if(isNaN(month)) {
      return '';
    }
    else {
      return  year + '-' + month + '-' + day;
    }
  }

  function getValues() {
    let valuesObj = {
      'contains': $searchInput.val(),
      'type': getTypes('val'),
      'date_offset': getOffset(),
      'range_start': getDate($('#fromDate').val()) === '' ? '' :  getDate($('#fromDate').val()) + '-01',
      'range_end': formatEndDate(getDate($('#to').val()))
    };

    for(var key in valuesObj) {
      let str = String(valuesObj[key]);

      if (valuesObj[key] === null || valuesObj[key] === undefined || str.replace(/\s/g,'') ==='') {
        delete valuesObj[key];
      }
    }

    formatURL(valuesObj);
  }

  function formatEndDate(dateToFormat) {
    let updatedDate = dateToFormat.split('-');
    let newest = lastDayOfMonth(updatedDate[0], updatedDate[1]);
    return newest;
  }

  function formatURL(obj) {
    let urlString = '?'+$.param(obj).replace('+', ' ');
    window.location.href = window.location.pathname + urlString;
  }

  function getOffset() {
    return $('.search-custom-dropdowns__radio:checked:not(#from):not(#all-dates)').val();
  }

  function getDate(date) {
    let dateString = /(0?[1-9]|1[0-2])\/(\d{4})/.test(date);
    if($('#from').is(':checked')) {
      if(dateString === true) {
        let str = date.split('/');
        let newStr = str[1] + '-' +str[0];
        return newStr;
      }
      else {
        return '';
      }
    }
    else {
      return '';
    }
  }


  function getTypes(prop) {
    let arr = [];
    if($('#all-types').is(':checked')) {
      $('.search-custom-dropdowns__checkbox:not(#all-types)').each(function() {
        // prop === 'val' ? arr.push($(this).val()) : arr.push($(this).attr('data-label'));
      });
    }
    else {
      $('.search-custom-dropdowns__checkbox:checked:not(#all-types)').each(function() {
        prop === 'val' ? arr.push($(this).val()) : arr.push($(this).attr('data-label'));
      });
    }

    return arr;
  }

  function toggleSuggestions() {
    var val = $(this).val();
    var url = '/solr/callback/nodes?title=' + val;

    $.ajax(url, {
      success: function(data) {
        let results;
        let wrapper;
        if(data.length === 0) {
          wrapper = `<ul><li><a href="/search?contains=${val}">No results found</a></li></ul>`;
        }
        else {
          results = createResult(data);
          wrapper = `<ul>${results}</ul>`;
        }

        $('.typeahead-results').empty().append(wrapper);
      },
      error: function() {

      }
    });

    if($(this).val().length > 0) {
      $resultsWrapper.addClass('_inactive');
      $typeAheadResults.removeClass('_inactive');
    }
    else {
      clearTimeout(menuTime);
      let menuTime = setTimeout(function() {
        $resultsWrapper.removeClass('_inactive');
        $typeAheadResults.addClass('_inactive');
      }, 250);
    }
  }

  function createResult(data) {
    var results = '';
    for(let i = 0; i < data.length; i++) {
      let thisValue = decodeEntities(data[i].value);
      results += `<li><a href="${data[i].link}">${thisValue}</a></li>`;
    }
    return results;
  }

  function toggleModal() {
    $modal.toggleClass('_active');

    if($modal.hasClass('_active')) {
      $('.search__close-modal').focus();
    }

    $('body').toggleClass('_search-open');

  }

  function toggleDrop(event) {
    event.stopPropagation();
    if ($(window).width() > 768) {
      $(this).closest('.search-custom-dropdowns__input').toggleClass('_active');
    }
    else {
      $(this).closest('.search-custom-dropdowns__input').toggleClass('_active');
      $(this).closest('.search-custom-dropdowns__input-wrapper').siblings().find('.search-custom-dropdowns__input').removeClass('_active');
    }
  }
}

export { init as init };
